import { CloseIcon } from "assets/icons";
import React from "react";
import { Sheet } from "react-modal-sheet";
import styled from "styled-components";

export interface BottomSheetProps {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  title?: string;
  children?: React.ReactNode;
  hasAuthorityToDelete?: boolean;
}

const BottomSheet = ({
  isOpen,
  title,
  children,
  setOpen,
  hasAuthorityToDelete,
}: BottomSheetProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Sheet
      isOpen={isOpen}
      onClose={handleClose}
      detent="content-height"
      key={title}
      disableDrag
      onClick={(e) => {
        // react-modal-sheet에 있는 backdrop이 native pointer이벤트와 react click 이벤트를 발생시키는데
        // 해당 라이브러리 단에서 react click 이벤트 전파를 막을 방법이 없어 이벤트 상위 전파를 막기 위한 코드
        e.stopPropagation();
      }}
      style={{
        touchAction: "none",
        zIndex: isOpen ? "99999900" : "-1",
        visibility: isOpen ? "visible" : "hidden",
      }}
    >
      <Sheet.Container>
        <SheetLayout>
          <header>
            <h2>{title}</h2>
            <CloseIcon
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            />
          </header>
          <div>
            {React.Children.map(children, (child, index) => {
              const isLastChild = index === React.Children.count(children) - 1;
              const hideLastPadding =
                isLastChild && hasAuthorityToDelete === false;

              return (
                <div
                  style={{
                    padding: hideLastPadding ? "0" : "1.2rem 1.6rem",
                  }}
                >
                  {child}
                </div>
              );
            })}
          </div>
        </SheetLayout>
      </Sheet.Container>
      <Sheet.Backdrop
        onTap={(e) => {
          e.stopImmediatePropagation();
          e.stopPropagation();
          handleClose();
        }}
      />
    </Sheet>
  );
};

export default BottomSheet;

const SheetLayout = styled(Sheet.Content)`
  padding: 2rem 0rem;

  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 1.6rem;

    margin-bottom: 1rem;
    h2 {
      ${({ theme }) => theme.typography.body1.medium};
    }

    svg {
      cursor: pointer;
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    ${({ theme }) => theme.typography.body3.regular};

    max-height: 50vh;
    overflow-y: auto;
  }
`;
